import React, { useEffect } from 'react';
import M from 'materialize-css';
const messageRef = React.createRef();

function CustomTextArea(props) {
  const { id, label, value, setValue, ref, hide } = props;

  useEffect(() => {
    M.AutoInit();
    if (messageRef.current) {
      M.textareaAutoResize(messageRef.current);
    }
  }, []);

  if (hide) {
    return <div />;
  }

  return (
    <div className="input-field col s12">
      <textarea
        ref={ref}
        id={id}
        className="materialize-textarea"
        name="marketingMessage"
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
      <label htmlFor="taMarketingMessage">{label}</label>
    </div>
  );
}

export default CustomTextArea;
